import styled from "styled-components";

interface SidebarProps {
  children: React.ReactNode;
}

const StyledDiv = styled.div`
  width: 20%;
  flex-direction: column;
`;

export const Sidebar = ({ children }: SidebarProps) => {
  return <StyledDiv className="bg-white d-flex">{children}</StyledDiv>;
};
